import { SOFTLINE_CONFIG_DASHBOARD_COMPONENT } from '@softline/application';
import { ChecklistWidgetComponent } from './checklist-widget/checklist-widget.component';
import { SOFTLINE_PERMISSION_CHECKLISTE } from '../checkliste.shared';

export function provideChecklistWidget() {
  return [
    {
      provide: SOFTLINE_CONFIG_DASHBOARD_COMPONENT,
      multi: true,
      useValue: {
        component: ChecklistWidgetComponent,
        permission: `${SOFTLINE_PERMISSION_CHECKLISTE}.WIDGET`,
      },
    },
  ];
}
